'use client';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import ClutchWidget from '@/components/ClutchWidget';
import TeamAvatars from '@/components/TeamAvatars';
import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';

import styles from './CTASection.module.scss';

const CTASection = () => {
  const t = useTranslations('common');

  return (
    <Container component="section" maxWidth={false} classes={{ root: styles.root }} className={styles.containerWrapper}>
      <Box className={styles.backgroundPatterns}>
        <Image
          src="/images/cta/background.webp"
          alt=""
          fill
          className={styles.backgroundImage}
          sizes="(max-width: 1536px) 100vw, 1536px"
          priority
        />
      </Box>
      <Box className={styles.backgroundPatternsMobile}>
        <Image
          src="/images/cta/background-mobile.webp"
          alt=""
          fill
          className={styles.backgroundImage}
          sizes="(max-width: 1536px) 100vw, 1536px"
          priority
        />
      </Box>
      <Box className={styles.fadeOverlay} />
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column-reverse', lg: 'row' }}
          spacing={{ xs: 10, lg: 6 }}
          alignItems="flex-start"
          justifyContent="space-between"
          sx={{ position: 'relative', zIndex: 2 }}
        >
          <Stack spacing={3} sx={{ maxWidth: { xs: '100%', lg: 680 } }}>
            <Typography variant="h3" component="h2" color={colors.graytone950}>
              {t('cta.title')}
            </Typography>
            <Typography variant="body1" color={colors.graytone600} sx={{ maxWidth: { xs: '100%', lg: 394 } }}>
              {t('cta.description')}
            </Typography>
            <Box>
              <Link href="/contact" className={styles.buttonLink}>
                <Button variant="outlined">{t('getInTouch')}</Button>
              </Link>
            </Box>
          </Stack>
          <Stack spacing={4} pt={{ xs: 0, lg: 6 }}>
            <ClutchWidget variant="compact" />
            <TeamAvatars />
            <Stack direction="row" alignItems="flex-start" spacing={2} mt={1}>
              <Box className={styles.dividerLine} />
              <Typography component="p" variant="subtitle2" color={colors.graytone600} sx={{ maxWidth: 318 }}>
                {t('cta.testimonial')}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Container>
  );
};

export default CTASection;
